// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__j6fiS","labelCaption":"Label_labelCaption__CBEcx"};